/* Chocolate Boutique — vanilla theme JS (no libraries) */
(function () {
  'use strict';

  var R = window.routes || {
    cart_add: '/cart/add',
    cart_change: '/cart/change',
    cart: '/cart'
  };

  var money = function (cents) {
    try {
      return (cents / 100).toLocaleString(undefined, {
        style: 'currency',
        currency: window.Shopify && Shopify.currency ? Shopify.currency.active : 'GBP'
      });
    } catch (e) {
      return '£' + (cents / 100).toFixed(2);
    }
  };

  /* ---------- Mobile menu ---------- */
  var burger = document.querySelector('[data-ct-burger]');
  var nav = document.querySelector('[data-ct-nav]');

  function closeMenu() {
    document.body.classList.remove('ct-menu-open');
    if (burger) burger.setAttribute('aria-expanded', 'false');
  }

  if (burger && nav) {
    burger.addEventListener('click', function () {
      var open = document.body.classList.toggle('ct-menu-open');
      burger.setAttribute('aria-expanded', open ? 'true' : 'false');
    });

    nav.querySelectorAll('a').forEach(function (a) {
      a.addEventListener('click', closeMenu);
    });
  }

  /* ---------- Variant selectors ---------- */
  document.querySelectorAll('[data-ct-product]').forEach(function (root) {
    var sel = root.querySelector('[data-ct-variant]');
    var idInput = root.querySelector('[data-ct-id]');
    var priceEl = root.parentElement ? root.parentElement.querySelector('[data-ct-price-current]') : null;

    if (!sel || !idInput) return;

    sel.addEventListener('change', function () {
      var opt = sel.options[sel.selectedIndex];
      idInput.value = opt.value;

      if (priceEl && opt.dataset.price) {
        priceEl.textContent = opt.dataset.price;
      }
    });
  });

  /* ---------- Cart drawer ---------- */
  var drawer = document.querySelector('[data-ct-drawer]');

  function openDrawer() {
    if (drawer) {
      drawer.setAttribute('aria-hidden', 'false');
      document.body.style.overflow = 'hidden';
    }
  }

  function closeDrawer() {
    if (drawer) {
      drawer.setAttribute('aria-hidden', 'true');
      document.body.style.overflow = '';
    }
  }

  document.querySelectorAll('[data-ct-cart-open]').forEach(function (b) {
    b.addEventListener('click', function () {
      renderCart();
      openDrawer();
    });
  });

  document.querySelectorAll('[data-ct-cart-close]').forEach(function (b) {
    b.addEventListener('click', closeDrawer);
  });

  document.addEventListener('keydown', function (e) {
    if (e.key === 'Escape') closeDrawer();
  });

  function setCount(n) {
    document.querySelectorAll('[data-ct-cart-count]').forEach(function (el) {
      el.textContent = n;
    });
  }

  function renderCart() {
    if (!drawer) return;

    fetch(R.cart + '.js', {
      headers: {
        'Accept': 'application/json'
      }
    })
    .then(function (r) {
      return r.json();
    })
    .then(function (cart) {
      setCount(cart.item_count);

      var items = drawer.querySelector('[data-ct-cart-items]');
      var empty = drawer.querySelector('[data-ct-cart-empty]');
      var foot = drawer.querySelector('[data-ct-cart-foot]');
      var sub = drawer.querySelector('[data-ct-cart-subtotal]');

      if (!items) return;

      items.innerHTML = '';

      if (cart.item_count === 0) {
        if (empty) empty.style.display = '';
        if (foot) foot.hidden = true;
        return;
      }

      if (empty) empty.style.display = 'none';
      if (foot) foot.hidden = false;
      if (sub) sub.textContent = money(cart.total_price);

      cart.items.forEach(function (item) {
        var li = document.createElement('li');
        li.className = 'ct-line';

        var img = item.image
          ? '<div class="ct-line__img"><img src="' + item.image.replace(/(\.[^.\/]+)(\?.*)?$/, '_120x$1$2') + '" alt=""></div>'
          : '<div class="ct-line__img"></div>';

        var variant = item.variant_title && item.variant_title.indexOf('Default') === -1
          ? '<span class="ct-line__v">' + item.variant_title + '</span>'
          : '';

        li.innerHTML =
          img +
          '<div><p class="ct-line__t">' + item.product_title + '</p>' +
          variant +
          '<div class="ct-line__q">Qty ' + item.quantity + '</div>' +
          '<button class="ct-line__rm" data-key="' + item.key + '">Remove</button></div>' +
          '<div class="ct-line__p">' + money(item.final_line_price) + '</div>';

        items.appendChild(li);
      });

      items.querySelectorAll('[data-key]').forEach(function (btn) {
        btn.addEventListener('click', function () {
          changeQty(btn.getAttribute('data-key'), 0);
        });
      });
    })
    .catch(function () {});
  }

  function changeQty(key, qty) {
    fetch(R.cart_change + '.js', {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
        'Accept': 'application/json'
      },
      body: JSON.stringify({
        id: key,
        quantity: qty
      })
    })
    .then(function () {
      renderCart();
    })
    .catch(function () {});
  }

  /* ---------- AJAX add to cart — fixed for mobile ---------- */
  document.querySelectorAll('[data-ct-atc], [data-sila-atc]').forEach(function (form) {
    form.addEventListener('submit', function (e) {
      e.preventDefault();
      e.stopPropagation();
      e.stopImmediatePropagation();

      var root =
        form.closest('[data-ct-product]') ||
        form.closest('[data-sila-product]') ||
        form.closest('.ct-pdp__info') ||
        document;

      var btn = form.querySelector('button[type="submit"]');
      var idInput =
        form.querySelector('[data-ct-id]') ||
        form.querySelector('[data-sila-id]') ||
        form.querySelector('input[name="id"]');

      var fallbackId =
        form.getAttribute('data-default-variant-id') ||
        form.getAttribute('data-variant-id') ||
        '';

      var variantButtons = root.querySelectorAll('[data-multi-variant], [data-sila-variant]');

      var ids = [];

      if (variantButtons.length) {
        ids = Array.from(variantButtons)
          .filter(function (button) {
            return button.classList.contains('is-active');
          })
          .map(function (button) {
            return button.getAttribute('data-variant-id');
          })
          .filter(Boolean);

        if (!ids.length) {
          alert('Please choose at least one option.');
          return;
        }
      } else {
        var singleId = '';

        if (idInput && idInput.value) {
          singleId = idInput.value;
        } else if (fallbackId) {
          singleId = fallbackId;
        }

        if (!singleId) {
          alert('Product option missing. Please refresh and try again.');
          return;
        }

        ids = [singleId];
      }

      var original = btn ? btn.textContent : '';

      if (btn) {
        btn.disabled = true;
        btn.textContent = 'Adding…';
      }

      var items = ids.map(function (id) {
        return {
          id: Number(id),
          quantity: 1
        };
      });

      fetch(R.cart_add + '.js', {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
          'Accept': 'application/json'
        },
        body: JSON.stringify({
          items: items
        })
      })
      .then(function (r) {
        return r.json().then(function (d) {
          if (!r.ok) throw d;
          return d;
        });
      })
      .then(function () {
        window.location.href = R.cart;
      })
      .catch(function () {
        if (btn) {
          btn.disabled = false;
          btn.textContent = original;
        }

        if (ids.length === 1) {
          window.location.href = '/cart/add?id=' + encodeURIComponent(ids[0]) + '&quantity=1';
        } else {
          window.location.href = R.cart;
        }
      });
    }, true);
  });

  /* ---------- Product page media gallery ---------- */
  document.querySelectorAll('[data-ct-gallery]').forEach(function (gallery) {
    var panels = gallery.querySelectorAll('[data-ct-media-panel]');
    var thumbs = gallery.querySelectorAll('[data-ct-thumb]');

    if (!panels.length || !thumbs.length) return;

    thumbs.forEach(function (thumb) {
      thumb.addEventListener('click', function () {
        var index = Number(thumb.getAttribute('data-media-index'));

        panels.forEach(function (panel, i) {
          panel.classList.toggle('is-active', i === index);

          var video = panel.querySelector('video');
          if (video && i !== index) {
            video.pause();
          }
        });

        thumbs.forEach(function (t) {
          t.classList.remove('is-active');
        });

        thumb.classList.add('is-active');
      });
    });
  });

  /* keep header count in sync on load */
  if (drawer) renderCart();

  /* ---------- Reset Add to Box button when coming back from cart ---------- */
  function resetProductAddButtons() {
    document.querySelectorAll('.ct-atc button[type="submit"], [data-sila-add-selected]').forEach(function (btn) {
      var text = (btn.textContent || '').toLowerCase();

      if (text.indexOf('adding') === -1 && text.indexOf('added') === -1) {
        return;
      }

      btn.disabled = false;

      var root =
        btn.closest('[data-ct-product]') ||
        btn.closest('[data-sila-product]') ||
        btn.closest('.ct-pdp__info') ||
        document;

      var variantButtons = root.querySelectorAll('[data-sila-variant], [data-multi-variant]');
      var selectedButtons = root.querySelectorAll('[data-sila-variant].is-active, [data-multi-variant].is-active');

      if (variantButtons.length) {
        if (selectedButtons.length === 0) {
          btn.textContent = 'Choose options';
        } else if (selectedButtons.length === 1) {
          btn.textContent = 'Add 1 option to Box';
        } else {
          btn.textContent = 'Add ' + selectedButtons.length + ' options to Box';
        }
      } else {
        btn.textContent = 'Add to Box';
      }
    });
  }

  window.addEventListener('pageshow', function () {
    resetProductAddButtons();
  });

  document.addEventListener('visibilitychange', function () {
    if (!document.hidden) {
      resetProductAddButtons();
    }
  });
  /* ---------- Announcement bar slider ---------- */
  function initAnnouncementSlider() {
    document.querySelectorAll('[data-ct-announcement]').forEach(function (root) {
      if (root.dataset.sliderReady === 'true') return;

      var items = root.querySelectorAll('.ct-bar__item');

      if (!items.length || items.length < 2) return;

      root.dataset.sliderReady = 'true';

      var index = 0;

      setInterval(function () {
        items[index].classList.remove('is-active');
        index = (index + 1) % items.length;
        items[index].classList.add('is-active');
      }, 5000);
    });
  }

  initAnnouncementSlider();

  document.addEventListener('shopify:section:load', function () {
    initAnnouncementSlider();
  });

  /* ---------- Hero slider ---------- */
  function initHeroSlider() {
    document.querySelectorAll('[data-ct-hero-slider]').forEach(function (root) {
      if (root.dataset.heroReady === 'true') return;

      var slides = root.querySelectorAll('.ct-hero-slide');
      var dots = root.querySelectorAll('.ct-hero-dot');

      if (!slides.length || slides.length < 2) return;

      root.dataset.heroReady = 'true';

      var autoplay = root.dataset.autoplay === 'true';
      var speed = parseInt(root.dataset.speed || '5000', 10);
      var index = 0;
      var timer = null;
      var startX = 0;

      function showSlide(i) {
        slides.forEach(function (slide, s) {
          slide.classList.toggle('is-active', s === i);
        });

        dots.forEach(function (dot, d) {
          dot.classList.toggle('is-active', d === i);
          dot.setAttribute('aria-current', d === i ? 'true' : 'false');
        });

        index = i;
      }

      function nextSlide() {
        showSlide((index + 1) % slides.length);
      }

      function prevSlide() {
        showSlide((index - 1 + slides.length) % slides.length);
      }

      function startAuto() {
        if (!autoplay) return;
        stopAuto();
        timer = setInterval(nextSlide, speed);
      }

      function stopAuto() {
        if (timer) {
          clearInterval(timer);
          timer = null;
        }
      }

      dots.forEach(function (dot) {
        dot.addEventListener('click', function () {
          stopAuto();
          showSlide(parseInt(dot.dataset.ctHeroDot, 10));
          startAuto();
        });
      });

      root.addEventListener('mouseenter', stopAuto);
      root.addEventListener('mouseleave', startAuto);

      root.addEventListener('touchstart', function (e) {
        startX = e.changedTouches[0].clientX;
      }, { passive: true });

      root.addEventListener('touchend', function (e) {
        var endX = e.changedTouches[0].clientX;
        var diff = endX - startX;

        if (Math.abs(diff) > 40) {
          stopAuto();

          if (diff < 0) {
            nextSlide();
          } else {
            prevSlide();
          }

          startAuto();
        }
      }, { passive: true });

      startAuto();
    });
  }

  initHeroSlider();

  document.addEventListener('shopify:section:load', function () {
    initHeroSlider();
  });

})();